import dayjs from 'dayjs'

const setCookie = (cName: string, cValue: string, time?: number): void => {
  const timeout = dayjs()
    .add(time ?? 10, 'minute')
    .toString()
  document.cookie = `${cName}=${cValue};expires=${timeout};"`
}

const getCookie = (cName: string): string => {
  cName += '='
  const cookieData = document.cookie
  let start = cookieData.indexOf(cName)
  let cValue = ''
  if (start !== -1) {
    start += cName.length
    let end = cookieData.indexOf(';', start)
    if (end === -1) end = cookieData.length
    cValue = cookieData.substring(start, end)
  }
  return unescape(cValue)
}

const deleteCookie = (cName: string): void => {
  document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

const useCookies = () => {
  function set(cName: string, cValue: string, time?: number) {
    setCookie(cName, cValue, time)
  }
  function get(cName: string) {
    return getCookie(cName)
  }
  function del(cName: string) {
    deleteCookie(cName)
  }

  return {
    set,
    get,
    del,
  }
}
export default useCookies
